import styled from 'styled-components';
import { screenMd } from 'constants/styles/breakpoints';

export const ImpersonateContainer = styled.div`
  background: linear-gradient(90deg, #b67cff 0%, #9885e6 100%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 19px 12px;
  ${screenMd} {
    padding: 15px 20px;
  }
  > p {
    margin-bottom: 0;
    font-size: 13px;
    line-height: 17px;
    font-weight: 700;
    color: #fff;
    padding-right: 10px;
    ${screenMd} {
      font-size: 16px;
    }
    > span,
    a {
      color: inherit;
      border-bottom: 1px solid #fff;
    }
  }
`;
